import moment from 'moment/moment'
import {formatosDefault} from '@/commons/constants'

export default (data) => {
    if (!data) {
        return '-'
    }
    return moment(data).format(formatosDefault.DATA_HORA)
}
